/* R&B · Client care (sections/rb-client-care.liquid).
   1. Country switch: both selects (delivery, returns) show the same country's table / fees.
   2. Search: filters the questions (all topics), opens the matches, hides the tables while searching.
   3. Topics: active state follows the scroll; a click scrolls calmly (instant with reduced motion).
   4. Answers open and close with a .34s height animation (<details> works without the script). */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var EASE = 'cubic-bezier(.22,.61,.36,1)';

  function init(root) {
    if (!root || root.dataset.rbccInit) return;
    root.dataset.rbccInit = '1';

    /* 1 · country */
    var sels = root.querySelectorAll('[data-rbcc-mk]');
    function setMk(mk) {
      sels.forEach(function (s) { s.value = mk; });
      root.querySelectorAll('[data-rbcc-for]').forEach(function (b) { b.hidden = b.getAttribute('data-rbcc-for') !== mk; });
    }
    sels.forEach(function (s) { s.addEventListener('change', function () { setMk(s.value); }); });

    /* 4 · answers */
    root.querySelectorAll('[data-rbcc-it]').forEach(function (d) {
      var sum = d.querySelector('summary'), an = d.querySelector('.rbcc__an');
      sum.addEventListener('click', function (e) {
        if (reduce.matches || !an.animate) return;
        e.preventDefault();
        if (d._anim) d._anim.cancel();
        if (d.open) {
          var h = an.offsetHeight;
          d.classList.add('is-closing');
          d._anim = an.animate([{ height: h + 'px' }, { height: '0px' }], { duration: 340, easing: EASE });
          d._anim.onfinish = function () { d.open = false; d.classList.remove('is-closing'); d._anim = null; };
        } else {
          d.open = true;
          var h2 = an.offsetHeight;
          d._anim = an.animate([{ height: '0px' }, { height: h2 + 'px' }], { duration: 340, easing: EASE });
          d._anim.onfinish = function () { d._anim = null; };
        }
      });
    });

    /* 2 · search */
    var q = root.querySelector('[data-rbcc-q]'), clr = root.querySelector('[data-rbcc-clear]');
    var hits = root.querySelector('[data-rbcc-hits]'), none = root.querySelector('[data-rbcc-none]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-rbcc-it]'));
    var tps = Array.prototype.slice.call(root.querySelectorAll('[data-rbcc-tp]'));
    items.forEach(function (it) { it._txt = it.textContent.replace(/\s+/g, ' ').toLowerCase(); it._was = it.open; });
    var t1 = root.getAttribute('data-hit1'), tn = root.getAttribute('data-hits');
    function search() {
      var v = (q.value || '').trim().toLowerCase(), n = 0;
      clr.hidden = !v;
      root.classList.toggle('is-searching', !!v);
      items.forEach(function (it) {
        var show = !v || v.split(/\s+/).every(function (w) { return it._txt.indexOf(w) >= 0; });
        it.hidden = !show;
        if (v) it.open = show; else it.open = false;
        if (show && v) n++;
      });
      tps.forEach(function (tp) {
        tp.hidden = !!v && !tp.querySelector('[data-rbcc-it]:not([hidden])');
        var x = tp.querySelector('.rbcc__x'); if (x) x.hidden = !!v;
      });
      hits.textContent = v ? (n === 1 ? t1 : (n ? tn.replace('{n}', n) : '')) : '';
      none.hidden = !v || n > 0;
    }
    if (q) {
      q.addEventListener('input', search);
      q.addEventListener('keydown', function (e) { if (e.key === 'Escape') { q.value = ''; search(); } });
      clr.addEventListener('click', function () { q.value = ''; search(); q.focus(); });
    }

    /* 3 · topics */
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-rbcc-go]'));
    function mark(id) {
      links.forEach(function (a) { a.classList.toggle('is-on', a.getAttribute('data-rbcc-go') === id); });
      var chip = root.querySelector('.rbcc__chips [data-rbcc-go="' + id + '"]');
      if (chip && chip.parentNode.scrollWidth > chip.parentNode.clientWidth) {
        var p = chip.parentNode, x = chip.offsetLeft - 16;
        p.scrollTo ? p.scrollTo({ left: x, behavior: reduce.matches ? 'auto' : 'smooth' }) : (p.scrollLeft = x);
      }
    }
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('data-rbcc-go'), el = document.getElementById(id);
        if (!el) return;
        e.preventDefault();
        if (q && q.value) { q.value = ''; search(); }
        el.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + id);
        mark(id);
      });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) mark(en.target.id); });
      }, { rootMargin: '-30% 0px -60% 0px' });
      tps.forEach(function (tp) { io.observe(tp); });
    }
    /* arriving with #delivery or #returns (the old pages redirect here) */
    if (location.hash) {
      var tgt = document.getElementById(location.hash.slice(1));
      if (tgt && root.contains(tgt)) { mark(tgt.id); setTimeout(function () { tgt.scrollIntoView({ block: 'start' }); }, 60); }
    }
  }

  function boot() { document.querySelectorAll('[data-rbcc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
